"use strict";

require("core-js/modules/es6.string.starts-with");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactKonva = require("react-konva");

var _ramda = require("ramda");

var _images = require("../utils/images");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Background =
/*#__PURE__*/
function (_Component) {
  _inherits(Background, _Component);

  function Background() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Background);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Background)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      image: null
    };
    _this.setImage =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var elementImage, image;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              elementImage = null;

              if (!(_this.props.getFileUrl && !(0, _ramda.startsWith)('data:image', _this.props.settings.background))) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return (0, _images.getBase64FromUrl)(_this.props.getFileUrl(_this.props.settings.background));

            case 4:
              elementImage = _context.sent;
              _context.next = 8;
              break;

            case 7:
              elementImage = _this.props.settings.background;

            case 8:
              image = new window.Image();
              image.src = elementImage;

              image.onload = function () {
                return _this.setState({
                  image: image
                });
              };

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    _this.calcPosition = function (type, imgWidth, imgHeight) {
      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height;
      return {
        x: /left/.test(type) ? 0 : /right/.test(type) ? width - imgWidth : width / 2 - imgWidth / 2,
        y: /top/.test(type) ? 0 : /bottom/.test(type) ? height - imgHeight : height / 2 - imgHeight / 2
      };
    };

    _this.getProps = function () {
      var image = _this.state.image;

      if (!image) {
        return {};
      }

      var _this$props2 = _this.props,
          width = _this$props2.width,
          height = _this$props2.height,
          _this$props2$settings = _this$props2.settings,
          backgroundAlign = _this$props2$settings.backgroundAlign,
          coverBackground = _this$props2$settings.coverBackground;
      var naturalWidth = image.naturalWidth,
          naturalHeight = image.naturalHeight;

      if (!coverBackground) {
        return _objectSpread({
          width: naturalWidth,
          height: naturalHeight
        }, _this.calcPosition(backgroundAlign, naturalWidth, naturalHeight));
      }

      var modifiedHeight = naturalHeight / (naturalWidth / width);
      var modifiedWidth = naturalWidth / (naturalHeight / height);
      var acrossWidth = height > modifiedWidth || height < modifiedHeight && modifiedWidth < width;

      var position = _this.calcPosition(backgroundAlign, modifiedWidth, modifiedHeight);

      return acrossWidth ? {
        width: width,
        height: modifiedHeight,
        y: position.y
      } : {
        height: height,
        width: modifiedWidth,
        x: position.x
      };
    };

    return _this;
  }

  _createClass(Background, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev) {
      if (!(0, _ramda.equals)(prev.settings.background, this.props.settings.background)) {
        this.setImage();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          settings = _this$props3.settings,
          width = _this$props3.width,
          height = _this$props3.height;
      var image = this.state.image;
      return settings.pattern ? _react.default.createElement(_reactKonva.Rect, {
        fillPatternImage: image,
        fillPatternScaleX: settings.patternScale,
        fillPatternScaleY: settings.patternScale,
        width: width,
        height: height
      }) : _react.default.createElement(_reactKonva.Image, _extends({
        image: image
      }, this.getProps()));
    }
  }]);

  return Background;
}(_react.Component);

exports.default = Background;
Background.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  settings: _propTypes.default.object,
  getFileUrl: _propTypes.default.func
};